import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=50803878&"
import script from "./subscription.vue?vue&type=script&lang=ts&"
export * from "./subscription.vue?vue&type=script&lang=ts&"
import style0 from "./subscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports